export default __webpack_public_path__ + "static/media/drown_m.41afff0e.mp3";